/* eslint-disable sonarjs/no-duplicate-string */
import type { ThemeConfig } from 'antd';

export const THEME_CONFIG: ThemeConfig = {
    token: {
        fontFamily: 'var(--font-family-main)',
        colorText: 'var(--primary-text-color)',
    },
    components: {
        Button: {
            borderRadius: 10,
            controlHeight: 48,
            colorPrimary: 'var(--primary)',
            colorPrimaryHover: 'var(--button-primary-hover-color)',
            colorPrimaryActive: 'var(--button-primary-active-color)',
            defaultBg: 'var(--button-default-bg)',
            defaultBorderColor: 'var(--button-default-border-color)',
            defaultHoverBg: 'transparent',
            defaultActiveBg: 'transparent',
            colorError: 'var(--danger)',
            colorTextDisabled: 'var(--tertiary-text-color)',
            borderColorDisabled: 'var(--tertiary-text-color)',
            colorLink: 'var(--primary-text-color)',
            colorLinkHover: 'var(--button-link-hover-color)',
            colorLinkActive: 'var(--button-link-active-color)',
        },
        Checkbox: {
            colorPrimary: 'var(--primary)',
            colorBgContainer: 'transparent',
            colorBorder: 'var(--border-color)',
        },
        Layout: {
            colorBgLayout: 'var(--bg-layout)',
            siderBg: 'var(--bg-color)',
            headerBg: 'var(--bg-color)',
            triggerBg: 'var(--sider-trigger-bg)',
            triggerColor: 'var(--primary-text-color)',
        },
        Input: {
            borderRadius: 10,
            colorBgContainer: 'var(--control-bg)',
            colorBorder: 'var(--control-border-bg)',
            colorBgContainerDisabled: 'var(--control-disabled-bg)',
            colorTextDisabled: 'var(--control-disabled-text-color)',
            colorTextPlaceholder: 'var(--control-placeholder-color)',
            colorTextDescription: 'var(--tertiary-text-color)',
            colorPrimaryHover: 'var(--primary)',
            colorIcon: 'var(--tertiary-text-color)',
        },
        InputNumber: {
            borderRadius: 10,
            colorBgContainer: 'var(--control-bg)',
            colorBorder: 'var(--control-border-bg)',
            colorBgContainerDisabled: 'var(--control-disabled-bg)',
            colorTextDisabled: 'var(--control-disabled-text-color)',
            colorTextPlaceholder: 'var(--control-placeholder-color)',
            colorTextDescription: 'var(--tertiary-text-color)',
            colorPrimaryHover: 'var(--primary)',
            colorIcon: 'var(--tertiary-text-color)',
        },
        Typography: {
            fontWeightStrong: 500,
        },
        Message: {
            paddingXS: 0,
            borderRadiusLG: 0,
            fontSize: 16,
            contentPadding: 0,
        },
        Dropdown: {
            colorBgElevated: 'var(--bg-color)',
            controlItemBgHover: 'var(--dropdown-item-bg-hover)',
            controlItemBgActive: 'var(--dropdown-item-bg-item)',
            colorPrimary: 'var(--primary)',
            controlItemBgActiveHover: 'var(--dropdown-item-bg-item-hover)',
            paddingBlock: 8,
            controlPaddingHorizontal: 24,
        },
        Menu: {
            activeBarBorderWidth: 0,
        },
        Avatar: {
            colorTextPlaceholder: 'var(--avatar-bg)',
            colorTextLightSolid: 'var(--primary-text-color)',
        },
        Notification: {
            colorBgElevated: 'var(--notification-bg)',
            colorIcon: 'var(--tertiary-text-color)',
            colorIconHover: 'var(--secondary-text-color)',
        },
        Drawer: {
            colorBgElevated: 'var(--drawer-bg)',
            colorSplit: 'var(--border-color)',
        },
        Card: {
            colorBorderSecondary: 'var(--border-color)',
            colorBgContainer: 'var(--card-bg)',
        },
        Switch: {
            colorPrimary: 'var(--primary)',
        },
        Divider: {
            colorSplit: 'var(--border-color)',
        },
        Select: {
            colorBgContainer: 'var(--control-bg)',
            colorBorder: 'var(--control-border-bg)',
            colorTextQuaternary: 'var(--secondary-text-color)',
            colorTextPlaceholder: 'var(--control-placeholder-color)',
            colorBgElevated: 'var(--select-elevated-panel-bg)',
            optionSelectedBg: 'var(--primary)',
            colorTextTertiary: 'var(--tertiary-text-color)',
            colorBgContainerDisabled: 'var(--control-disabled-bg)',
            colorTextDisabled: 'var(--control-disabled-text-color)',
        },
        Empty: {
            colorTextDescription: 'var(--tertiary-text-color)',
        },
        Popover: {
            colorBgElevated: 'var(--popconfirm-elevated-panel-bg)',
        },
        Table: {
            colorBgContainer: 'var(--table-bg)',
            borderColor: 'var(--border-color)',
            colorText: 'var(--secondary-text-color)',
            headerSortHoverBg: 'var(--table-header-sort-hover-bg)',
            // bodySortBg: 'var(--table-body-sort-bg)',
            bodySortBg: 'transparent',
            headerSplitColor: 'transparent',
            colorPrimary: 'var(--primary)',
            stickyScrollBarBg: 'var(--scroll-bar-trubm-bg)',
            headerBg: 'var(--table-header-bg)',
            headerBorderRadius: 0,
        },
        Modal: {
            colorBgElevated: 'var(--modal-bg)',
        },
        Alert: {
            colorText: 'var(--primary-text-color)',
            colorTextHeading: 'var(--primary-text-color)',
            colorWarningBg: 'var(--warning-bg)',
            colorWarningBorder: 'var(--warning-border)',
            colorInfoBg: 'var(--info-bg)',
            colorInfoBorder: 'var(--info-picto)',
            colorErrorBg: 'var(--warning-bg)',
            colorErrorBorder: 'var(--danger-color)',
        },
        Form: {
            colorTextDescription: 'var(--secondary-text-color)',
            colorError: 'var(--danger-color)',
        },
        List: {
            colorSplit: 'var(--border-color)',
            colorBorder: 'var(--border-color)',
        },
        DatePicker: {
            colorBgContainer: 'var(--control-bg)',
            colorBorder: 'var(--border-color)',
            colorText: 'var(--primary-text-color)',
            colorTextPlaceholder: 'var(--primary-text-color)',
            colorTextDisabled: 'var(--tertiary-text-color)',
            colorTextDescription: 'var(--tertiary-text-color)',
            colorBgElevated: 'var(--secondary-bg-color)',
            colorIcon: 'var(--tertiary-text-color)',
            colorPrimary: 'var(--primary)',
            cellActiveWithRangeBg: 'var(--date-picker-selected-range-bg)',
        },
        Calendar: {
            fullBg: '',
            fullPanelBg: '',
            colorBgContainer: '',
            colorText: 'var(--secondary-text-color)',
            colorSplit: 'var(--border-color)',
            colorPrimary: 'var(--primary)',
            itemActiveBg: 'var(--calendar-active-item-bg)',
            colorTextDisabled: 'var(--calendar-placeholder-color)',
        },
        Radio: {
            colorBgContainer: 'var(--control-bg)',
            colorBorder: 'var(--border-color)',
            colorPrimary: 'var(--primary)',
        },
        Tag: {
            colorPrimary: 'var(--primary)',
        },
        Spin: {
            colorBgContainer: 'var(--spin-bg)',
            dotSizeLG: 120,
            dotSize: 90,
            dotSizeSM: 50,
        },
        Segmented: {
            trackBg: 'var(--segmented-bg)',
            itemSelectedBg: 'var(--primary)',
            itemColor: 'var(--primary-text-color)',
            itemSelectedColor: 'var(--white)',
        },
        Tabs: {
            colorBorderSecondary: 'var(--border-color)',
        },
        Rate: {
            starBg: 'var(--input-toggle-bg-off)',
            starSize: 28,
        },
    },
};
